import SEO from "@/components/site/SEO";
import SolutionsSection from "@/components/sections/Solutions";
import CTA from "@/components/sections/CTA";
import { Truck, Building2, Briefcase, Car, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const DETAILS = [
  {
    icon: Car,
    title: "Individuals",
    body: "Stop writing your number on a paper note. One sticker, zero exposure, a lifetime of masked calls.",
    points: ["Single tag covers one vehicle", "Family pack covers up to 3", "Lifetime relay, no subscription"],
  },
  {
    icon: Truck,
    title: "Fleets & Couriers",
    body: "Replace your dispatch board for parking calls. Custom QR routes scanners directly to the assigned driver.",
    points: ["Co-branded stickers", "Per-vehicle scan analytics", "CSV exports for ops", "API for dispatch systems"],
  },
  {
    icon: Building2,
    title: "Societies & Lots",
    body: "Manage visitor vehicles, gate-pass logs and boom-barrier integrations — one QR per stall.",
    points: ["Resident & visitor tags", "Boom-barrier API", "In/out timestamp logs", "Multi-property dashboard"],
  },
  {
    icon: Briefcase,
    title: "Resellers & Garages",
    body: "Sell SECQRE under your brand. 20-tag starter kits, in-store displays, dedicated managers.",
    points: ["Counter-top display kit", "Sales training included", "50% marketing reimbursement", "City-wide exclusive rights"],
  },
];

export default function Solutions() {
  return (
    <div data-testid="page-solutions">
      <SEO title="Solutions" description="SECQRE for individuals, fleets, communities and resellers. Find the right fit." path="/solutions" />
      <section className="pt-32 md:pt-40 pb-12">
        <div className="container-secqre">
          <span className="overline">— Solutions</span>
          <h1 className="mt-4 font-heading font-black text-5xl sm:text-6xl lg:text-7xl tracking-tight" data-testid="solutions-page-title">
            One sticker.<br />Many problems solved.
          </h1>
        </div>
      </section>

      <section className="pb-20">
        <div className="container-secqre grid md:grid-cols-2 gap-6">
          {DETAILS.map((d, i) => (
            <div key={i} className="rounded-2xl border border-[#E2E8F0] bg-white p-8 md:p-10" data-testid={`solution-detail-${i}`}>
              <div className="w-12 h-12 rounded-lg bg-[#0F172A] text-white inline-flex items-center justify-center mb-5">
                <d.icon className="w-5 h-5" />
              </div>
              <h2 className="font-heading font-bold text-3xl">{d.title}</h2>
              <p className="mt-3 text-[#475569] leading-relaxed">{d.body}</p>
              <ul className="mt-5 space-y-2">
                {d.points.map((p, k) => (
                  <li key={k} className="flex items-start gap-3 text-sm text-[#0A0A0A]">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#FFD600] shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-[#0A0A0A] underline decoration-[#FFD600] decoration-4 underline-offset-4" data-testid={`solution-detail-cta-${i}`}>
                Get started <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          ))}
        </div>
      </section>

      <SolutionsSection />
      <CTA />
    </div>
  );
}
